import React, { useEffect, useState } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";

import Header from "../../components/home/Header/Header";
import HeroSlider from "../../components/HeroSlider/HeroSlider";
import Games from "../../components/Games/Games";
import Services from "../../components/Services/Services";
import Footer from "../../components/Footer/Footer";

function Home() {

    
      React.useEffect(() => {
        AOS.init({
          offset: 100,
          duration: 800,
          easing: "ease-in-sine",
          delay: 100,
        });
        AOS.refresh();
      }, []);

    useEffect(() => {
        const scrollToGames = () => {
            if (window.location.hash !== "#games") return;

            setTimeout(() => {
                const gamesSection = document.getElementById("games");

                if (gamesSection) {
                    gamesSection.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                    });
                }
            }, 100);
        };

        // Səhifə ilk açıldıqda
        scrollToGames();

        // Home artıq açıqdırsa hash dəyişməsini tut
        window.addEventListener("hashchange", scrollToGames);

        return () => {
            window.removeEventListener("hashchange", scrollToGames);
        };
    }, []);

    return (
        <div className="min-h-screen mt-[62px] md:mt-[78px] bg-slate-950 text-white">

            <Header />

            <HeroSlider />

            <Games />

            <Services />

            <Footer />

        </div>
    );
}

export default Home;